/* BYLOS — Maison interactions */
(() => {
  const d = document;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cfg = window.BYLOS || {};
  const FREE = cfg.freeShip || 10000;
  const fine = matchMedia('(pointer: fine)').matches;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const money = (cents) => {
    const fmt = cfg.moneyFormat || '${{amount}}';
    const n = cents / 100;
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');

  let toastT;
  const toast = (msg) => {
    const t = d.querySelector('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-visible'), 2400);
  };

  /* ================= Cart ================= */
  const drawer = () => d.querySelector('[data-cart-drawer]');
  let lastFocus;
  const lock = (on) => d.documentElement.classList.toggle('no-scroll', on);
  const openCart = () => {
    const el = drawer(); if (!el) return;
    lastFocus = d.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true);
    setTimeout(() => el.querySelector('.drawer__close')?.focus(), 50);
  };
  const closeCart = () => {
    const el = drawer(); if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); lock(false);
    lastFocus?.focus?.();
  };

  let catalog = null;
  const getCatalog = () => {
    if (catalog) return catalog;
    try { catalog = JSON.parse(d.querySelector('[data-catalog]')?.textContent || '[]').filter(Boolean); } catch (e) { catalog = []; }
    return catalog;
  };

  const renderCart = (cart) => {
    d.querySelectorAll('[data-cart-count]').forEach((n) => { n.textContent = `(${cart.item_count})`; });
    const el = drawer(); if (!el) return;
    const empty = cart.item_count === 0;
    el.querySelector('[data-cart-empty]').hidden = !empty;
    el.querySelector('[data-cart-foot]').hidden = empty;
    el.querySelector('[data-ship]').hidden = empty;
    el.querySelector('[data-cart-total]').textContent = money(cart.total_price);

    const left = Math.max(FREE - cart.total_price, 0);
    el.querySelector('[data-ship-text]').textContent = left > 0
      ? `Add ${money(left)} for complimentary shipping`
      : 'Your order ships complimentary within Australia';
    el.querySelector('[data-ship-bar]').style.width = `${Math.min(100, (cart.total_price / FREE) * 100)}%`;

    el.querySelector('[data-cart-lines]').innerHTML = cart.items.map((it, i) => `
      <div class="line" data-line="${i + 1}">
        <a class="line__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(sized(it.image, 240))}" alt="${esc(it.product_title)}" loading="lazy">` : ''}</a>
        <div class="line__info">
          <div class="line__top"><a href="${esc(it.url)}">${esc(it.product_title)}</a><span>${money(it.final_line_price)}</span></div>
          ${it.variant_title ? `<p class="line__meta">Size ${esc(it.variant_title)}</p>` : ''}
          <div class="line__bottom">
            <div class="qty"><button type="button" data-line-qty="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button type="button" data-line-qty="${it.quantity + 1}" aria-label="Increase">+</button></div>
            <button type="button" class="line__remove" data-line-qty="0">Remove</button>
          </div>
        </div>
      </div>`).join('');

    // Upsell: other styles not already in the bag
    const inBag = new Set(cart.items.map((i) => i.product_id));
    const picks = getCatalog().filter((p) => !inBag.has(p.id)).slice(0, 2);
    const up = el.querySelector('[data-upsell]');
    up.hidden = empty || picks.length === 0;
    el.querySelector('[data-upsell-list]').innerHTML = picks.map((p) => `
      <div class="upsell__item">
        <a class="line__img" href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
        <div>
          <a class="upsell__name" href="${esc(p.url)}">${esc(p.title)}</a>
          <p class="upsell__price">${esc(p.price)}</p>
          <div class="card__sizes">${p.variants.map((v) => `<button type="button" class="size-mini" data-quick-add="${v.id}" ${v.available ? '' : 'disabled'} aria-label="Add ${esc(p.title)} size ${esc(v.title)}">${esc(v.title.charAt(0))}</button>`).join('')}</div>
        </div>
      </div>`).join('');
  };

  const fetchCart = () => fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const refresh = () => fetchCart().then(renderCart).catch(() => {});
  const json = async (r) => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; };

  const addToCart = (body) => fetch(`${root}cart/add.js`, body instanceof FormData
    ? { method: 'POST', headers: { Accept: 'application/json' }, body }
    : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
    .then(json).then(refresh);

  const changeLine = (line, quantity) => {
    const el = drawer(); el?.classList.add('is-busy');
    return fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) })
      .then(json).then(renderCart).catch((e) => toast(e.message)).finally(() => el?.classList.remove('is-busy'));
  };

  const quickAdd = (btn) => {
    const fd = new FormData(); fd.append('id', btn.dataset.quickAdd); fd.append('quantity', '1');
    btn.classList.add('is-added');
    addToCart(fd).then(() => { openCart(); toast('Added to bag'); })
      .catch((e) => toast(e.message)).finally(() => setTimeout(() => btn.classList.remove('is-added'), 600));
  };

  /* ================= Product ================= */
  const initProduct = (section) => {
    const form = section.querySelector('[data-product-form]') || section.querySelector('form[action*="/cart/add"]');
    const dataEl = section.querySelector('[data-product-json]');
    if (!form || !dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const idInput = form.querySelector('[data-variant-id]');
    const btn = form.querySelector('[data-add-btn]');
    const label = form.querySelector('[data-add-label]');
    const priceEl = section.querySelector('[data-price]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const note = section.querySelector('[data-stock-note]');
    const err = form.querySelector('[data-form-error]');

    /* Second pair */
    const pairEl = section.querySelector('[data-pair]');
    const pairData = pairEl ? JSON.parse(pairEl.querySelector('[data-pair-json]').textContent) : [];
    let pairOn = false; let pairProduct = null; let pairVariant = null; let mainCents = 0; let closePair = () => {};
    let setOn = false; let setCents = 0; let setItems = () => []; let setReady = () => false;
    const setLabel = () => {
      if (btn.disabled) return;
      if (setOn) label.textContent = `Add the set — ${money(setCents)}`;
      else if (pairOn && pairVariant) label.textContent = `Add 2 to bag — ${money(mainCents + pairVariant.cents)}`;
      else label.textContent = 'Add to bag';
    };
    if (pairEl) {
      const toggle = pairEl.querySelector('[data-pair-toggle]');
      const body = pairEl.querySelector('[data-pair-body]');
      const sizesEl = pairEl.querySelector('[data-pair-sizes]');
      const summary = pairEl.querySelector('[data-pair-summary]');
      const swatches = [...pairEl.querySelectorAll('[data-pair-index]')];
      const renderSizes = () => {
        sizesEl.innerHTML = pairProduct.variants.map((v) => `<button type="button" class="size${v.available ? '' : ' is-soldout'}" role="radio" aria-checked="${pairVariant && pairVariant.id === v.id}" data-pair-variant="${v.id}" ${v.available ? '' : 'disabled'}>${esc(v.title)}</button>`).join('');
      };
      const sync = () => {
        summary.textContent = pairOn && pairVariant ? `${pairProduct.name} — ${pairVariant.title}` : (pairOn ? 'Select a size' : 'Choose any colour and size');
        pairEl.classList.toggle('is-on', pairOn);
        setLabel();
      };
      const choose = (i) => {
        pairProduct = pairData[i];
        swatches.forEach((sw) => sw.setAttribute('aria-checked', String(Number(sw.dataset.pairIndex) === i)));
        const keep = pairVariant && pairProduct.variants.find((v) => v.title === pairVariant.title && v.available);
        pairVariant = keep || pairProduct.variants.find((v) => v.available) || null;
        renderSizes(); sync();
      };
      const pre = swatches.findIndex((sw) => sw.getAttribute('aria-checked') === 'true');
      toggle.addEventListener('click', () => {
        pairOn = !pairOn;
        toggle.setAttribute('aria-expanded', String(pairOn));
        if (pairOn) { body.hidden = false; requestAnimationFrame(() => body.classList.add('is-open')); if (!pairProduct) choose(pre < 0 ? 0 : pre); }
        else { body.classList.remove('is-open'); setTimeout(() => { if (!pairOn) body.hidden = true; }, 450); }
        sync();
      });
      swatches.forEach((sw) => sw.addEventListener('click', () => choose(Number(sw.dataset.pairIndex))));
      closePair = () => { if (pairOn) toggle.click(); };
      sizesEl.addEventListener('click', (e) => {
        const b = e.target.closest('[data-pair-variant]'); if (!b || b.disabled) return;
        pairVariant = pairProduct.variants.find((v) => String(v.id) === b.dataset.pairVariant);
        sizesEl.querySelectorAll('[role="radio"]').forEach((x) => x.setAttribute('aria-checked', String(x === b)));
        sync();
      });
    }

    /* Complete the set: a second option, exclusive with the second pair */
    const setEl = section.querySelector('[data-set]');
    setCents = setEl ? Number(setEl.dataset.setCents) : 0;
    if (setEl) {
      const tg = setEl.querySelector('[data-set-toggle]');
      const body = setEl.querySelector('[data-set-body]');
      const isPh = setEl.hasAttribute('data-set-placeholder');
      const rows = [...setEl.querySelectorAll('[data-set-row]')];
      const pick = (row, idx) => { const c = row.querySelectorAll('[data-set-chip]')[idx]; if (!c || c.disabled) return; row.querySelectorAll('[data-set-chip]').forEach((x) => x.setAttribute('aria-checked', String(x === c))); };
      setItems = () => rows.map((r) => Number(r.querySelector('[data-set-chip][aria-checked="true"]')?.dataset.v) || 0);
      setReady = () => !isPh && setItems().every(Boolean);
      const setOpen = (on) => {
        setOn = on; tg.setAttribute('aria-expanded', String(on)); setEl.classList.toggle('is-on', on);
        if (on) { body.hidden = false; requestAnimationFrame(() => body.classList.add('is-open')); closePair(); }
        else { body.classList.remove('is-open'); setTimeout(() => { if (!setOn) body.hidden = true; }, 450); }
        setLabel();
      };
      tg.addEventListener('click', () => setOpen(!setOn));
      const rowsEl = setEl.querySelector('[data-set-rows]');
      const mixBtn = setEl.querySelector('[data-set-mix]');
      const noteEl = setEl.querySelector('[data-set-note]');
      const mainIdx = () => Number(setEl.querySelector('[data-set-all][aria-checked="true"]')?.dataset.setAll || 0);
      const applyMain = () => rows.forEach((r) => pick(r, mainIdx()));
      applyMain();
      setEl.addEventListener('click', (e) => {
        const all = e.target.closest('[data-set-all]');
        if (all) {
          setEl.querySelectorAll('[data-set-all]').forEach((x) => x.setAttribute('aria-checked', String(x === all)));
          applyMain(); return;
        }
        if (e.target.closest('[data-set-mix]') && rowsEl) {
          const open = rowsEl.hidden;
          rowsEl.hidden = !open;
          mixBtn.setAttribute('aria-expanded', String(open));
          mixBtn.querySelector('[data-set-mix-label]').textContent = open ? 'Same size for all' : 'Mix sizes by colour';
          if (noteEl) noteEl.textContent = open ? 'One of every colour. Choose a size for each.' : 'One of every colour, all in your size.';
          if (!open) applyMain();
          setEl.querySelector('.set__main')?.classList.toggle('is-muted', open);
          return;
        }
        const chip = e.target.closest('[data-set-chip]'); if (!chip || chip.disabled) return;
        pick(chip.closest('[data-set-row]'), Number(chip.dataset.setChip));
      });
      if (pairEl) {
        const pt = pairEl.querySelector('[data-pair-toggle]');
        pt.addEventListener('click', () => { if (pairOn && setOn) setOpen(false); });
      }
    }

    const selected = () => [...form.querySelectorAll('.option [role="radiogroup"]')].map((g) => g.querySelector('[aria-checked="true"]')?.dataset.value ?? null);
    const update = () => {
      const sel = selected();
      const v = data.variants.find((x) => x.options.every((o, i) => o === sel[i]));
      err.hidden = true;
      if (!v) { btn.disabled = true; label.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.textContent = v.price; if (stickyPrice) stickyPrice.textContent = v.price;
      btn.disabled = !v.available;
      mainCents = v.cents || 0;
      label.textContent = v.available ? 'Add to bag' : 'Sold out';
      setLabel();
      if (note) {
        note.classList.remove('is-low');
        if (!v.available) note.textContent = 'This size is currently sold out.';
        else if (v.qty !== null && v.qty > 0 && v.qty <= 10) { note.textContent = `Only ${v.qty} left in this size`; note.classList.add('is-low'); }
        else note.textContent = 'In stock, ready to dispatch';
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };

    form.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-option-index]'); if (!chip) return;
      const g = chip.closest('[role="radiogroup"]');
      g.querySelectorAll('[role="radio"]').forEach((c) => c.setAttribute('aria-checked', 'false'));
      chip.setAttribute('aria-checked', 'true');
      const lab = form.querySelector(`[data-option-label="${chip.dataset.optionIndex}"]`);
      if (lab) lab.textContent = ` — ${chip.dataset.value}`;
      update();
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      if (setOn && !setReady()) { err.textContent = 'The full set arrives with Icarus, Dune and Espresso. Coming soon.'; err.hidden = false; return; }
      btn.classList.add('is-loading');
      const body = setOn
        ? { items: setItems().map((id) => ({ id, quantity: 1, properties: { _set: 'Collection 01' } })) }
        : pairOn && pairVariant
          ? { items: [{ id: Number(idInput.value), quantity: 1 }, { id: pairVariant.id, quantity: 1 }] }
          : new FormData(form);
      addToCart(body)
        .then(() => { btn.classList.remove('is-loading'); label.textContent = 'Added'; openCart(); setTimeout(update, 1600); })
        .catch((ex) => { btn.classList.remove('is-loading'); err.textContent = ex.message; err.hidden = false; });
    });

    // Default to first available size if the preselected one is sold out
    const first = form.querySelector('[role="radiogroup"]');
    const cur = first?.querySelector('[aria-checked="true"]');
    if (cur && cur.classList.contains('is-soldout')) first.querySelector('[role="radio"]:not(.is-soldout)')?.click(); else update();

    // Sticky add-to-bag (mobile)
    const sticky = section.querySelector('[data-sticky-atc]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show));
      }).observe(btn);
      sticky.querySelector('[data-sticky-add]').addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : btn.click());
    }

    // Gallery counter (mobile swipe)
    const gallery = section.querySelector('[data-gallery]');
    const count = section.querySelector('[data-gallery-count]');
    if (gallery && count) {
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
        count.textContent = `${i} / ${data.images.length}`;
      }, { passive: true });
    }

    // Lightbox with click-to-zoom
    const lb = section.querySelector('[data-lightbox]');
    if (lb && data.images.length) {
      const img = lb.querySelector('[data-lightbox-img]');
      const stage = lb.querySelector('[data-lightbox-stage]');
      const lbCount = lb.querySelector('[data-lightbox-count]');
      let idx = 0;
      const show = (i) => {
        idx = (i + data.images.length) % data.images.length;
        lb.classList.remove('is-zoomed'); img.style.transformOrigin = '50% 50%';
        img.src = data.images[idx]; img.alt = `${section.querySelector('h1')?.textContent || ''} — image ${idx + 1}`;
        lbCount.textContent = data.images.length > 1 ? `${idx + 1} / ${data.images.length}` : '';
      };
      const open = (i) => { show(i); lb.classList.add('is-open'); lock(true); lb.querySelector('[data-lightbox-close]').focus(); };
      const close = () => { lb.classList.remove('is-open', 'is-zoomed'); lock(false); };
      section.querySelectorAll('[data-zoom]').forEach((b) => b.addEventListener('click', () => open(+b.dataset.zoom)));
      lb.querySelector('[data-lightbox-close]').addEventListener('click', close);
      lb.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => show(idx - 1));
      lb.querySelector('[data-lightbox-next]')?.addEventListener('click', () => show(idx + 1));
      stage.addEventListener('click', (e) => {
        const r = stage.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        lb.classList.toggle('is-zoomed');
      });
      stage.addEventListener('mousemove', (e) => {
        if (!lb.classList.contains('is-zoomed')) return;
        const r = stage.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      });
      let sx = null;
      stage.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (sx === null || lb.classList.contains('is-zoomed')) return;
        const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1)); sx = null;
      });
      d.addEventListener('keydown', (e) => {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') show(idx + 1);
        if (e.key === 'ArrowLeft') show(idx - 1);
      });
    }
  };

  /* ================= Magnetic CTA ================= */
  const initMagnet = () => d.querySelectorAll('[data-magnet]').forEach((zone) => {
    const btn = zone.querySelector('[data-magnet-target]');
    const lab = zone.querySelector('[data-magnet-label]');
    if (!btn) return;
    const light = (e) => {
      const r = btn.getBoundingClientRect();
      btn.style.setProperty('--mx', `${e.clientX - r.left}px`);
      btn.style.setProperty('--my', `${e.clientY - r.top}px`);
    };
    if (fine && !still) {
      zone.addEventListener('pointermove', (e) => {
        const r = btn.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2);
        const dy = e.clientY - (r.top + r.height / 2);
        btn.style.transform = `translate(${dx * 0.3}px, ${dy * 0.4}px)`;
        if (lab) lab.style.transform = `translate(${dx * 0.1}px, ${dy * 0.12}px)`;
        btn.classList.add('is-near'); light(e);
      });
      zone.addEventListener('pointerleave', () => {
        btn.style.transform = ''; if (lab) lab.style.transform = '';
        btn.classList.remove('is-near');
      });
    }
    btn.addEventListener('pointerdown', (e) => {
      light(e);
      const r = btn.getBoundingClientRect();
      const dot = d.createElement('span');
      dot.className = 'ripple';
      dot.style.left = `${e.clientX - r.left}px`; dot.style.top = `${e.clientY - r.top}px`;
      btn.appendChild(dot); dot.addEventListener('animationend', () => dot.remove());
    });
  });

  /* ================= Boot ================= */
  cfg.initProduct = initProduct;
  const boot = () => {
    d.querySelectorAll('[data-product]').forEach(initProduct);
    initMagnet();
    refresh();

    const hero = d.querySelector('[data-hero]');
    if (hero) requestAnimationFrame(() => hero.classList.add('is-ready'));

    d.addEventListener('click', (e) => {
      const q = e.target.closest('[data-quick-add]');
      if (q) { e.preventDefault(); if (!q.disabled) quickAdd(q); return; }
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      const lq = e.target.closest('[data-line-qty]');
      if (lq) changeLine(+lq.closest('[data-line]').dataset.line, Math.max(0, +lq.dataset.lineQty));
    });

    // Mobile menu
    const menu = d.querySelector('[data-menu]');
    const openBtn = d.querySelector('[data-menu-open]');
    const setMenu = (on) => {
      if (!menu) return;
      menu.classList.toggle('is-open', on); menu.setAttribute('aria-hidden', String(!on));
      openBtn?.setAttribute('aria-expanded', String(on)); lock(on);
    };
    openBtn?.addEventListener('click', () => setMenu(true));
    d.querySelector('[data-menu-close]')?.addEventListener('click', () => setMenu(false));
    d.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); if (menu?.classList.contains('is-open')) setMenu(false); } });

    // Header: transparent over hero, solid after
    const header = d.querySelector('[data-header]');
    if (header) {
      const onScroll = () => {
        const limit = hero ? hero.offsetHeight - header.offsetHeight - 40 : 0;
        header.classList.toggle('is-solid', !hero || window.scrollY > limit);
      };
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
      header.addEventListener('mouseenter', () => header.classList.add('is-solid'));
      header.addEventListener('mouseleave', onScroll);
    }

    // Cart page: auto-update quantities
    d.querySelectorAll('[data-auto-submit]').forEach((i) => i.addEventListener('change', () => i.form?.submit()));

    // Reveal on scroll
    if ('IntersectionObserver' in window && !still) {
      const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      d.querySelectorAll('.card, .editorial__copy, .section-head').forEach((el, i) => {
        el.classList.add('reveal'); el.style.transitionDelay = `${(i % 4) * 70}ms`; io.observe(el);
      });
    }
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
